var React = require('react');

function QuotesArticle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#00b2a9;}")),React.createElement("path",{"className":"cls-1","d":"M10.43,29.67A10.58,10.58,0,0,0,21,19,10.74,10.74,0,0,0,10.24,8.31H10a13.5,13.5,0,0,1,8.46-3,2.66,2.66,0,0,0,2.66-2.67A2.47,2.47,0,0,0,18.74,0,18.8,18.8,0,0,0,0,19H0A10.47,10.47,0,0,0,10.43,29.67Z","transform":"translate(0 0)","key":1}),React.createElement("path",{"className":"cls-1","d":"M35.44,29.67A10.58,10.58,0,0,0,46,19,10.73,10.73,0,0,0,35.27,8.31h-.21a13.55,13.55,0,0,1,8.47-3,2.66,2.66,0,0,0,2.66-2.67A2.48,2.48,0,0,0,43.76,0,18.82,18.82,0,0,0,25,19h0A10.48,10.48,0,0,0,35.44,29.67Z","transform":"translate(0 0)","key":2})]);
}

QuotesArticle.defaultProps = {"data-name":"Capa 1","viewBox":"0 0 46.19 29.67","width":"46.19","height":"29.67"};

module.exports = QuotesArticle;

QuotesArticle.default = QuotesArticle;
